$(document).ready(function () {
    var basicFontSize = parseInt($('body').css('font-size'));
    $('header .zoom__btn.neutral').first().data('font-size',basicFontSize);
    var fontSize = omCookieUtility.getCookie('aulFontSize');
    if(fontSize > 0){
        $('html,body').css('font-size',fontSize + 'px');
    }
    initMobileMenu();
})
$('header').on('click','.zoom__btn',function () {
    var newFontSize;
  if($(this).hasClass('plus')){
       newFontSize = parseInt($('html').css('font-size')) * 1.1;
      if(newFontSize > 30){
          newFontSize = 30
      }
  }
    if($(this).hasClass('minus')){
         newFontSize = parseInt($('html').css('font-size')) * 0.9;
        if(newFontSize < 11){
            newFontSize = 10
        }
    }
    if($(this).hasClass('neutral')){
        newFontSize = $('header .zoom__btn.neutral').first().data('font-size');
    }
    omCookieUtility.setCookie('aulFontSize',newFontSize,7);
    $('html,body').css('font-size',newFontSize + 'px');

    initMobileMenu();
});

var omCookieUtility = {
    getCookie: function(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    setCookie: function(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + ";SameSite=Lax";
    },
    deleteCookie: function(name){ setCookie(name, '', -1); }
};